import React from 'react';
import { Flex, HStack } from '@chakra-ui/react';

// Three-zone stage: the media is the fixed centre, and the two side zones flex equally
// around it.
//
// The `flex="1 1 0"` basis is what makes this work — with a zero basis both zones receive
// exactly the same width regardless of how much content each holds, so the media lands on
// the true horizontal centre of the screen. (Laying the pieces out in a row and centring
// the whole group instead would push the media off-centre by the difference between the
// text column and the rail.)
//
// Each zone then hugs the media: the left content aligns right, the rail aligns left, and
// the navigation is pushed to the far edge.
const LoopStage = ({
  left,
  center,
  right,
}: {
  left?: React.ReactNode;
  center: React.ReactNode;
  right: React.ReactNode;
}) => (
  <HStack width="100%" align="stretch" gap={{ base: '12px', md: '24px' }} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
    <Flex
      flex="1 1 0"
      minWidth={0}
      justify="flex-end"
      align="flex-start"
      display={{ base: left ? 'flex' : 'none', md: 'flex' }}
    >
      {left}
    </Flex>

    <Flex flexShrink={0} align="center" justify="center">
      {center}
    </Flex>

    <Flex flex="1 1 0" minWidth={0} justify="space-between" align="center" gap="12px">
      {right}
    </Flex>
  </HStack>
);

export default LoopStage;
